export const SET_BROWSER_NAME = 'browserTypes/SET_BROWSER_NAME';
export const SET_OS_NAME = 'browserTypes/SET_OS_NAME';
export const SET_WINDOW_INNER_WIDTH = 'browserTypes/SET_WINDOW_INNER_WIDTH';
export const UPDATE_MODIFIER_KEY_PRESSED_STATUS = 'browserTypes/UPDATE_MODIFIER_KEY_PRESSED_STATUS';
export const UPDATE_LEFT_PANEL_COLLAPSED_STATUS = 'browserTypes/UPDATE_LEFT_PANEL_COLLAPSED_STATUS';
export const SET_APPLICATION_FOCUS = 'browserTypes/SET_APPLICATION_FOCUS';
/** User changed the active tab (Design/Preview) */
export const APP_MODE_CHANGED = 'browserTypes/APP_MODE_CHANGED';
